
import { mixins, Component, Prop, Inject, Model } from 'nuxt-property-decorator';
import { InputDate } from '../design-system';
import FilterMixin from './FilterMixin';

@Component({
  components: {
    InputDate,
  },
})
export default class FilterDateTime extends mixins(FilterMixin) {
  @Inject() $validator;
  @Prop({ type: String, default: '' }) readonly label!: string;
  @Prop({ default: Object }) readonly validation!: object | string | null;

  @Model('input', { type: String, default: '' }) readonly value!: string;

  get innerValue(): string {
    return this.value;
  }

  set innerValue(datetime: string) {
    this.$emit('input', datetime);
    this.updateQuery(datetime, !datetime);
  }
}
